import autobind from 'core-decorators/lib/autobind';
import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import Helmet from "react-helmet";

import Header from '../components/Header';
import CookiePopup from '../components/CookiePopup';

import Footer from '../components/FooterDesktop';
import FacebookLoginButton from '../components/FacebookLoginButton';



export function load(callback) {
  window.gapi.client.load("sheets", "v4", () => {
    window.gapi.client.sheets.spreadsheets.values
      .get({
        spreadsheetId: "1wy_N0Y_ngipwWqXVNt7gjQM6hpUH42SOZwRsizOEsio",
        range: "Sheet1!A:B"
      })
      .then(
        response => {
          const data = response.result.values;
          const features = data.map((feature, i) => {
            if(i!==0){
              return({
                free: feature[0],
                pro: feature[1],
              })
            } else {
              return({
                free: "",
                pro: "",
              })
            }
          }) || [];
          callback({
            features
          });
        },
        response => {
          callback(false, response.result.error);
        }
      );
  });
}


@autobind
class PricingPage extends React.Component {
  state = {
    clientId: '358109697243-0mh5uh7m0fe1vknnracgn0gmi5nl4md3.apps.googleusercontent.com',
    apiKey: 'AIzaSyBRkHrs7PsGeWNB8IUzVMgDq3GHIaiysCQ',
    discoveryDocs: ["https://sheets.googleapis.com/$discovery/rest?version=v4"],
    scopes: "https://www.googleapis.com/auth/spreadsheets.readonly",
    spreadsheetId: "1wy_N0Y_ngipwWqXVNt7gjQM6hpUH42SOZwRsizOEsio",
    plans:[
      {free: "Custom domain", pro: "Portfolio"},
      {free: "Professional fashion portfolio", pro: "Latest"},
      {free: "Minimalistic design", pro: "About"},
      {free: "Unlimited categories", pro: "Contact"},
      {free: "Synced with Instagram (live)", pro: "Links"},
      {free: "Custom social links page", pro: "Free subdomain"},
      {free: "Custom about page", pro: "Unlimited links"},
      {free: "Custom contact page", pro: undefined},
      {free: "Built-in domain", pro: undefined},
      {free: "Ad-free", pro: undefined},
      {free: "Mobile dashboard access", pro: undefined},
      {free: "Google search optimisation (SEO)", pro: undefined},
      {free: "SSL security", pro: undefined},
      {free: "Great customer support", pro: undefined},
      {free: "Stress-free", pro: undefined}
    ],
  }


  initClient(){
    window.gapi.client
      .init({
        apiKey: this.state.apiKey,
        clientId: this.state.clientId,
        discoveryDocs: this.state.discoveryDocs
      })
      .then(() => {
      load(this.onLoad);
    });
  }

  onLoad(data, error){
    if (data) {
      console.log(data.features)
      this.setState({plans:data.features})
    } else {
      console.log(error)
    }
  }

  componentDidMount(){
    // window.gapi.load("client", this.initClient);
  }


  render() {
    return (
      <React.Fragment>
        <CookiePopup />
        
        <div className={css(styles.wrapper)}>
          <div className={css(styles.headerWrapper)}>
            <Header />
          </div>
          <Helmet>
            <title>Pricing | Minimaa</title>
            <meta name="description" content="Explore and discover other creatives using minimaa."/>
          </Helmet>
          <div className={css(styles.section)}>
            <div className={css(styles.section11)}>
              <div className={css(styles.h4Wrapper)}>
                <h4 className={css(styles.subtitle2)}>PRICING</h4>
              </div>
              <h3>Choose what best describes you</h3>
              <div className={css(styles.button3Wrapper)}>
                <FacebookLoginButton>
                  <button id="doitnow" className={css(styles.button)}>
                    <img className={css(styles.buttonImg)} src="../../assets/facebook.png" alt="minimaa facebook" />
                    CONTINUE WITH FACEBOOK
                  </button>
                </FacebookLoginButton>
              </div>
            </div>
            <div className={css(styles.section12)}>
              <div className={css(styles.pricingWrapper)}>
                <div className={css(styles.PlanOuterWrapper)}>
                  
                  <div className={css(styles.PlanWrapper)}>
                    <div className={css(styles.PlanTitle)}>STUDENT</div>
                    <div className={css(styles.PlanText)}>Professional portfolios can be costly right? But they just look so good. Well here’s an offer we think you’d love.</div>
                    <div className={css(styles.PriceWrapper)}>
                      <div className={css(styles.Price)}>
                        0
                        <div className={css(styles.Frequency)}>€/month</div>
                      </div>
                    </div>
                    <div className={css(styles.FeaturesWrapper)}>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Professional fashion portfolio</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Minimalistic design</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Unlimited categories</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Synced with Instagram (live)</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Custom social links page</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Custom about page</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Custom contact page</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Built-in domain</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Ad-free</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Mobile dashboard access</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Google search optimisation (SEO)</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>SSL security</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Great customer support</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Stress-free</div>
                      </div>
                    </div>
                  </div>

                  <div className={css(styles.PlanWrapperActive)}>
                    <div className={css(styles.PlanTitleWrapper)} ><div className={css(styles.PlanTitle)}>PRO</div><div className={css(styles.PROFlag)}>NEW!</div></div>
                    <div className={css(styles.PlanText)}>Go PRO and connect your own domain to your Minimaa portfolio.</div>
                    <div className={css(styles.PriceWrapper)}>
                      <div className={css(styles.Price)}>
                        5
                        <div className={css(styles.Frequency)}>€/month</div>
                      </div>
                    </div>
                    
                    <div className={css(styles.FeaturesWrapper)}>
                      <div className={css(styles.FeaturePRO)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Custom domain</div>
                        <div className={css(styles.PROFlag)}>PRO</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Professional fashion portfolio</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Minimalistic design</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Unlimited categories</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Synced with Instagram (live)</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Custom social links page</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Custom about page</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Custom contact page</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Built-in domain</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Ad-free</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Mobile dashboard access</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Google search optimisation (SEO)</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>SSL security</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Great customer support</div>
                      </div>
                      <div className={css(styles.Feature)}>
                        <img className={css(styles.Check)} src="../assets/featureCheck.svg" alt="minimaa check" />
                        <div className={css(styles.FeatureText)}>Stress-free</div>
                      </div>
                    </div>
                  </div>
                </div>
                   

              </div>
            </div>
          </div>



         
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

const styles = StyleSheet.create({



Color:{
  color:"#448AEE",
},
SubscriptionText:{
 marginTop:36,
 marginBottom:36,
 fontWeight:300,
 textAlign:"left",
 fontSize:14,
},

PlanTitleWrapper:{
  display:"flex",
  alignItems:"center",
},
PROFlag:{
  background:"#448AEE",
  color:"#fff",
  height:16,
  paddingLeft:4,
  paddingRight:4,
  fontSize:10,
  display:"flex",
  justifyContent:"center",
  alignItems:"center",
  borderRadius:4,
  marginLeft:8,
  userSelect:"none",
},

FeaturePRO:{
  display:"flex",
  alignItems:"center",
  marginBottom:20,
},


PlanButton:{
  position:"relative",
  userSelect: "none",
  display:"flex",
  height:32,
  marginTop:40,
  width:190,
  alignItems:"center",
  justifyContent: 'center',
  fontWeight:500,
  background:"#D6D6D6",
  color:"#000",
  cursor:"pointer",
  borderRadius:"20px",
  fontSize:12,
},

OuterWrapper:{
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight:"calc(100vh - 210px)",
  "@media (max-width: 500px)":{
    minHeight:"auto",
    marginTop:10,
  },
},


Title:{
  textAlign:"center",
  marginBottom:0,
  fontWeight:600,
  fontSize:24,
  "@media (max-height: 750px)":{
    marginBottom:50,
  },
  "@media (max-width: 500px)":{
    fontSize:22,
  },
},
PlanTitle:{
  textAlign:"left",
  marginBottom:0,
  fontWeight:500,
  fontSize:24,
  "@media (max-height: 750px)":{
    marginBottom:50,
  },
  "@media (max-width: 500px)":{
    fontSize:22,
  },
},

SubTitle:{
  fontWeight:400,
  marginBottom:10,
  fontSize:12,
  color:"#A3A3A3",
  textAlign:"center",
  "@media (max-width: 500px)":{
    fontSize:12,
  },
},



buttonImg:{
    width:16,
    marginTop:-1,
    marginRight:10,
  },


Text:{
 marginTop:26,
 marginBottom:36,
 textAlign:"center",
 fontSize:12,
},


PlanText:{
 marginTop:26,
 marginBottom:36,
 fontWeight:300,
 textAlign:"left",
 fontSize:14,
 height:70,
},





Logo:{
  width:110,
  position:"relative",
},

LogoWrapper:{
  width:"100%",
  height:140,
  display:"flex",
  position:"relative",
  justifyContent:"space-between",
  alignItems:"center",
  "@media (max-width: 500px)":{
    height:100,
  },
},


PlanOuterWrapper:{
  display:"flex",
  justifyContent:"space-between",
  alignItems:"flex-start",
  marginTop:50,
  "@media (max-width: 700px)":{
    flexDirection:"column",
    marginTop:20,
  },
},
PlanWrapper:{
  boxShadow: "0px 2px 12px rgba(21, 23, 54, 0.15)",
  width:"calc(50% - 70px)",
  padding:"44px 30px",
  justifyContent:"left",
  borderTop:"6px solid #fff",
  "@media (max-width: 700px)":{
    width:"calc(100% - 60px)",
    marginTop:30,
    padding:"44px 25px",
  },
},
PlanWrapperActive:{
  boxShadow: "0px 2px 12px rgba(21, 23, 54, 0.15)",
  width:"calc(50% - 90px)",
  padding:"44px 40px",
  justifyContent:"left",
  borderTop:"6px solid #3A80E4",
  "@media (max-width: 700px)":{
    width:"calc(100% - 90px)",
    marginTop:30,
  },
},
PriceWrapper:{
  display:"flex",

},
Valut:{
  lineHeight: "0px",
  fontSize:18,
},
Price:{
  display:"flex",
  alignItems:"flex-end",
  fontSize:60,
  lineHeight: "40px",
 
},
Frequency:{
  fontSize:12,
},

FeaturesWrapper:{
  marginTop:50,
},

Feature:{
  display:"flex",
  alignItems:"center",
  marginBottom:20,
},



FeatureText:{
 fontSize:12,
 marginLeft:8,
},
Check:{
  width:24,
},






















  wrapper:{
    width:"calc(100vw - 240px)",
    margin:"0 auto",
    maxWidth:1150,

    '@media (max-width: 1300px)': {
      width:"calc(100% - 130px)",
    },
    '@media (max-width: 1150px)': {
      width:"calc(100% - 60px)",
    },
    '@media (max-width: 420px)': {
      width:"calc(100% - 30px)",
    },
    '@media (max-width: 340px)': {
      width:"100%",
    },
  },


  section:{
    display:"flex",
    width:"calc(100% - 200px)",
    justifyContent:"space-between",
    margin:"150px auto",
    marginTop:50,
    paddingTop:100,
    '@media (max-width: 1400px)': {
      width:"calc(100% - 140px)",
    },
    '@media (max-width: 1150px)': {
      width:"calc(100% - 140px)",
    },
    '@media (max-width: 1020px)': {
      flexDirection:"column",
      alignItems:"center",
    },
    '@media (max-width: 800px)': {
      margin:"100px auto",
      marginTop:50,
      paddingTop:50,
    },
    '@media (max-width: 950px)': {
      width:"calc(100% - 80px)",
    },
    '@media (max-width: 600px)': {
      marginTop:96,
      paddingTop:0,
    },
    '@media (max-width: 420px)': {
      width:"calc(100% - 20px)",
    },
    '@media (max-width: 340px)': {
      width:"calc(100% - 40px)",
    }
  },
  section11:{
    width:280,
    minWidth:280,
    '@media (max-width: 1020px)': {
      textAlign:"center",
    },
    '@media (max-width: 420px)': {
      textAlign:"left",
      maxWidth:330,
      width:"100%"
    },
  },
  button:{
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
    border:"none",
    letterSpacing: "0.163636px",
    position:"relative",
    background:"#3A80E4",
    color:"#fff",
    textDecoration:"none",
    padding:"9px 22px 9px 20px",
    cursor:"pointer",
    outline:"none",
    borderRadius:"25px",
    fontSize:12,
    lineHeight:"14px",
    fontWeight:500,
    transition:"0.3s",
    ":hover":{
      background:"#266CD0",
    },
    '@media (max-width: 420px)': {
      fontSize:14,
    }
  },
  button3Wrapper:{
    marginTop:45,
  },

  subtitle:{
    color:"#A3A3A3",
    marginTop:48,
    fontSize:12,
    marginBottom:10,
  },



  section12:{
    display:"flex",
    flexWrap:"wrap",
    justifyContent:"flex-start",

    '@media (max-width: 1020px)': {
      maxWidth:700,
      width:"100%",
      justifyContent:"space-between",
    },
    '@media (max-width: 800px)': {
      justifyContent:"space-between",
    },
    
    '@media (max-width: 420px)': {
      width:"100%",
      maxWidth:320,
    }
  },
  h4Wrapper:{
    marginBottom:20,
    '@media (max-width: 420px)': {
      maxWidth:270,
    },
  },

 
 
  pricingWrapper:{
   width:"100%",
   '@media (max-width: 1020px)': {
      width:"100%",
      marginTop:50,
  },
  },
  text:{
    width:200,
    marginBottom:24,
    '@media (max-width: 1020px)': {
      textAlign:"center",
      margin:"0 auto",
      marginBottom:24,
    },
    '@media (max-width: 600px)': {
      width:240,
    },
    '@media (max-width: 420px)': {
      textAlign:"left",
      marginLeft:0,
      marginBottom:24,
    },
  },
  
  subtitle2:{
    fontSize:14,
    lineHeight:"21px",
    fontWeight:500,
  },


  
 


});

export default PricingPage;
